
import React, { useEffect } from "react";
import { AdminProvider } from "@/contexts/admin/AdminContext";
import { useLocation } from "react-router-dom";

interface AdminDataProviderProps {
  children: React.ReactNode;
}

const AdminDataProvider = ({ children }: AdminDataProviderProps) => {
  const location = useLocation();
  
  // Log location changes to help debug navigation issues
  useEffect(() => {
    console.log("AdminDataProvider - location changed:", location.pathname, location.state);
  }, [location]);
  
  return (
    <AdminProvider>
      {children}
    </AdminProvider>
  );
};

export default AdminDataProvider;
